import { ConfiguracoesMisc } from "./configuracoesMisc";
import { ConfiguracoesSite } from "./configuracoesSite";

export class Configuracoes {
  public static NAME;
  public static API = "";
  public static PDF;
  public static layoutExcelPedido;
  public static API2;
  public static IMAGELOGO;
  public static API_BANNERS;
  public static IMAGEBACKGROUND;
  public static API_GATEWAY_PAGAMENTO_URL;
  public static API_IMAGENS;
  public static API_DOCS;
  public static API_IMAGENS_PRODUTOS;
  public static API_BRANCH ="";
  public static layout;
  // public static gtagId;
  public static SITE: ConfiguracoesSite;
  public static MISC: ConfiguracoesMisc = {};
  public static modoVisualizacaoCatalogo;
  public static modoVisualizacaoPageProduto: number;
  public static descontoPorItem: number;
  public static layoutB2c: boolean;
  public static apiKeyGatewayPgto: string;
  public static mostraPrecoMinimoVenda: boolean;
  public static mostraCarrinho: boolean;
  public static acumulafiltrobusca: boolean;
  public static quantidade_minima: boolean
  public static mostraCarrinhoCatalogo: boolean;
  public static exibeVisualizacaoCatalogo: number[];
  public static exibeModalProdutoCatalogo: boolean;
  public static abrePedidoEmGrupo: boolean;
  public static validaCadastro: boolean = true;
  public static filtroColapsado: boolean;
  public static menuDinamico;
  public static tipoCliente: any;
  public static omiteBoleto;
  public static layoutMenu;
  public static limpaBusca;
  public static descricao_estoque_indisponivel;
  public static prod: boolean;
  public static cypher: boolean;
  public static idioma: string;
  public static LGPD: string;
   public static contato_material_marketing: string;
  public static CATALOGO_PDF: any;
  //https://themestr.app/theme
  //http://colormind.io/bootstrap/
  public static themes: Array<any> = [
    { id: "blush", color: "#b94b70" },
    { id: "chambray", color: "#396387" },
    { id: "matterhorn", color: "#4C3C42" },
    { id: "tobaccobrown", color: "#735641" },
    { id: "stilleto", color: "#97353A" },
    { id: "bazaar", color: "#917A81" },
    { id: "scarlate", color: "#8b0d13" },
    { id: "william", color: "#3C6167" },
    { id: "bastille", color: "#292530" },
  ];
  

  public static patchAppConfig(c) {
    this.menuDinamico = c.menuDinamico;
    this.omiteBoleto = c.omiteBoleto;
    this.layoutMenu = c.layoutMenu;
    this.LGPD = c.lgpd
    this.contato_material_marketing = c.contato_material_marketing
    this.limpaBusca = c.limpaBusca;
    this.NAME = c.NAME;
    this.filtroColapsado = c.filtroColapsado;
    this.API = c.API;
    this.PDF = c.PDF;
    this.CATALOGO_PDF = c.CATALOGO_PDF
    this.API_BANNERS = c.API_BANNERS ? c.API_BANNERS : null;
    this.API2 = c.API2;
    this.IMAGELOGO = c.IMAGELOGO;
    this.IMAGEBACKGROUND = c.IMAGEBACKGROUND;
    this.API_IMAGENS = c.API_IMAGENS;
    this.layoutExcelPedido = c.layoutExcelPedido;
    this.API_DOCS = c.API_DOCS;
    this.API_IMAGENS_PRODUTOS = c.API_IMAGENS_PRODUTOS;
    this.API_BRANCH = c.API_BRANCH;

    const layoutRaw = c.Layout;
    const layoutNormalized = ((): number => {
      if (layoutRaw === 4 || layoutRaw === "4") return 4;
      if (layoutRaw === 3 || layoutRaw === "3") return 3;
      if (layoutRaw === "pedido") return 4;
      if (layoutRaw === "pedido_grade") return 3;
      return 4;
    })();

    this.layout = layoutNormalized;
    this.modoVisualizacaoCatalogo = c.modoVisualizacaoCatalogo
      ? c.modoVisualizacaoCatalogo
      : "4x4";
    this.modoVisualizacaoPageProduto = c.modoVisualizacaoPageProduto
      ? c.modoVisualizacaoPageProduto
      : 1;
    this.descontoPorItem = c.descontoPorItem ? c.descontoPorItem : 0;
    this.layoutB2c = c.layoutB2c
    this.apiKeyGatewayPgto = c.APIKEY_GATEWAYPGTO;

    // if (c.gtagId) {
    //   this.gtagId = c.gtagId;
    // }
    if (c.miscCadCliNoAutEndereco) {
      this.MISC.miscCadCliNoAutEndereco = c.miscCadCliNoAutEndereco;
    }
    if (c.mostraCarrinhoCatalogo) {
      this.mostraCarrinhoCatalogo = c.mostraCarrinhoCatalogo;
    }
    if (c.quantidade_minima) {
      this.quantidade_minima = c.quantidade_minima;
    }
    if (c.registroLogin) {
      this.MISC.registroLogin = c.registroLogin;
    }
    if (c.prod) {
      this.prod = c.prod;
    }
    if (c.cypher) {
      this.cypher = c.cypher;
    }
    if (c.idioma) {
      this.idioma = c.idioma;
    }
    if (c.menuDinamico) {
      this.MISC.menuDinamico = c.menuDinamico;
    }
    if (c.tipoCliente) {
      this.tipoCliente = c.tipoCliente;
    }
    if (c.omiteBoleto) {
      this.omiteBoleto = c.omiteBoleto;
    }
    if (c.footer) {
      this.MISC.fotterProps = c.footer;
    }
    if (c.mostraPrecoMinimoVenda) {
      this.mostraPrecoMinimoVenda = c.mostraPrecoMinimoVenda;
    }
    if (c.mostraCarrinho !== null) {
      this.mostraCarrinho = c.mostraCarrinho;
    }
    if (c.acumulafiltrobusca !== null) {
      this.acumulafiltrobusca = c.acumulafiltrobusca;
    }
    if (c.exibeVisualizacaoCatalogo) {
      this.exibeVisualizacaoCatalogo = c.exibeVisualizacaoCatalogo;
    }
    if (c.abrePedidoEmGrupo) {
      this.abrePedidoEmGrupo = c.abrePedidoEmGrupo;
    }
    if (c.validaCadastro !== undefined) {
      this.validaCadastro = c.validaCadastro;
    }
    this.exibeModalProdutoCatalogo = c.exibeModalProdutoCatalogo;
    if (c.descricao_estoque_indisponivel) {
      this.MISC.descricao_estoque_indisponivel =
        c.descricao_estoque_indisponivel;
    }
    if (c.API_GATEWAY_PAGAMENTO_URL) {
      this.API_GATEWAY_PAGAMENTO_URL = c.API_GATEWAY_PAGAMENTO_URL;
    }
  }
}
